(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldAnchor', fbFieldAnchorDirective);

    function fbFieldAnchorDirective() {
        return {
            restrict: "EA",
            scope: {
                element:'=',
                model:'='
                //type: '@'
            },
            controller:fbFieldAnchorDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldAnchorDirectiveCtrl ($scope, $element, lodash, $compile, $interval) {
        var vm = this;
        var spam_protection = false;
        var start_protection_on_load = false;
        var duration = 0;
        var cloneElement = null;
        this.$onInit = function() {
            vm.click = click;

            spam_protection = lodash.get(vm.element, 'attr.spam_protection', false);
            start_protection_on_load = lodash.get(spam_protection, 'start_on_load', false);
            duration = lodash.get(spam_protection, 'duration', 0);
            vm.is_protected = start_protection_on_load;
            vm.protection_remaining = 0;

            if (start_protection_on_load) {
                registerProtection();
            }

            var template =
                '<a  ng-click="vm.click($event)" class="' + getClass() + '" ng-if="!vm.is_protected">' +
                '<i class="fa position-right" ng-class="\'fa-\' + vm.element.icon" ng-if="vm.element.icon"></i>' +
                '<%vm.element.label%>' +
                '</a><span ng-if="vm.is_protected"><%vm.element.label%> (<%vm.protection_remaining%>)</span>';
            $element.html(template);
            cloneElement = $compile($element.contents())($scope);

            $scope.$on('$destroy', onDestroy);
        }

        // function getIconClass() {
        //     return 'fa-'+lodash.get(vm, 'element.icon',' hide');
        // }

        function getClass() {
            return lodash.get(vm, 'element.class','');
        }

        function click($event) {
            var eventData = {
                targetScope: vm.element,
                target: $element,
                event: $event,
                model: vm.model
            };

            if (lodash.has(vm.element, 'event.click') && !lodash.get(vm.pageData, 'fbData.settings.view_only', false)) {
                $scope.$emit(vm.element.event.click, eventData);
            }
            registerProtection();
        }

        function registerProtection() {
            if (!!spam_protection) {
                vm.is_protected = true;
                vm.protection_remaining = duration;
                vm.protection_interval = $interval(function () {
                    if (vm.protection_remaining > 0) {
                        vm.protection_remaining = vm.protection_remaining - 1;
                    } else {
                        vm.is_protected = false;
                        $interval.cancel(vm.protection_interval);
                    }
                }, 1000);
            }
        }

        function onDestroy() {
            cloneElement.off();
        }
    }
})();